import React, { useEffect,useState } from 'react';
import TypeWriterStyles from './TypeWriter.module.css';
import useTypewriter from "react-typewriter-hook";

let index=0;
export default function TypeWriter({phrases,timeToWaitBeforeDelete}){
    const [displayedText,setDisplayedText]=useState('');
    const typeWriter = useTypewriter(displayedText);
    useEffect(
        () => {
            const interval = setInterval(() => {
                index = index > phrases.length-1
                    ? 0 
                    : ++index;
                setDisplayedText(phrases[index]);
            }, timeToWaitBeforeDelete);
            return function clear() {
                clearInterval(interval);
            };
            },
            [displayedText, phrases, timeToWaitBeforeDelete]
        );
    return <p className={TypeWriterStyles.TypeWriter}>
        {typeWriter}
    </p>
}